var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

_global.SENTRY_RELEASE = {
  id: "production_77b809122e70_172.18.0.2"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["noti_afreecatv_com@af_sentry"] = {
  id: "production_77b809122e70_172.18.0.2"
};